import axios from 'axios';
import { v4 as uuidv4 } from 'uuid'

const setDefaultHeader = () => {
    axios.defaults.headers.common['api_key'] = uuidv4()
    axios.defaults.baseURL = process.env.REACT_APP_URL;
}

export const apiGet = (url, params) => {
    setDefaultHeader();
    return axios.get(process.env.REACT_APP_EXPRESS + url, { params });
}

export const apiPost = (url, data) => {
    setDefaultHeader();
    return axios.post(process.env.REACT_APP_EXPRESS + url, data);
}